import React from 'react';

export default () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_23621_1899)">
        <path
          d="M14.1668 7.99967C14.1668 4.59392 11.4059 1.83301 8.00016 1.83301C4.59441 1.83301 1.8335 4.59392 1.8335 7.99967C1.8335 11.4054 4.59441 14.1663 8.00016 14.1663C11.4059 14.1663 14.1668 11.4054 14.1668 7.99967ZM7.50016 10.6663V7.99967C7.50016 7.72353 7.72402 7.49967 8.00016 7.49967C8.27631 7.49967 8.50016 7.72353 8.50016 7.99967V10.6663C8.50016 10.9425 8.27631 11.1663 8.00016 11.1663C7.72402 11.1663 7.50016 10.9425 7.50016 10.6663ZM8.00667 4.83301C8.28282 4.83301 8.50667 5.05687 8.50667 5.33301C8.50667 5.60915 8.28282 5.83301 8.00667 5.83301H8.00016C7.72402 5.83301 7.50016 5.60915 7.50016 5.33301C7.50016 5.05687 7.72402 4.83301 8.00016 4.83301H8.00667ZM15.1668 7.99967C15.1668 11.9577 11.9582 15.1663 8.00016 15.1663C4.04212 15.1663 0.833496 11.9577 0.833496 7.99967C0.833496 4.04163 4.04212 0.833008 8.00016 0.833008C11.9582 0.833008 15.1668 4.04163 15.1668 7.99967Z"
          fill="#F04438"
        />
      </g>
      <defs>
        <clipPath id="clip0_23621_1899">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
